import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link, useLocation } from "react-router-dom";
import MyProgess from "./MyProgess";
import nodeContext from "../Context/Notes/NotesContext";
import { useContext } from "react";

const MyNavbar = (props) => {
  const context = useContext(nodeContext);
  const { progVar } = context;
  let location = useLocation();
  const setActiveLink = (locc) => {
    let cla = "";
    cla = locc === "/" ? "home" : locc.slice(1);

    const allLinks = document.getElementsByClassName("nav-link");
    // to remove the active links from all the nav items
    for (let i = 0; i < allLinks.length; i++) {
      allLinks[i].classList.remove("active");
    }
    // // to add the active link to the the selected link
    const allAdded = document.getElementsByClassName(cla);
    for (let i = 0; i < allAdded.length; i++) {
      allAdded[i].classList.add("active");
    }
  };
  const handleOnLogout = () => {
    localStorage.setItem("token", "");
  };
  return (
    <>
      <Navbar
        expand="lg"
        className="navbar navbar-expand-lg navbar-dark bg default_font"
      >
        <Container>
          <Navbar.Brand href="#home">
            <Link className="navbar-brand home" to="/">
              {props.title}
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link>
                <Link
                  className="nav-link home active "
                  aria-current="page"
                  to="/"
                >
                  Home
                </Link>
              </Nav.Link>
              <Nav.Link href="#link">
                <Link className="nav-link about" to="/about">
                  About
                </Link>
              </Nav.Link>
            </Nav>
            {!localStorage.getItem("token") && (
              <form className="d-flex" role="search">
                <Link className=" btnClass btn mx-2" to="/login" role="button">
                  Login
                </Link>
                <Link className=" btnClass btn mx-2" to="/signup" role="button">
                  Sign Up
                </Link>
              </form>
            )}
            {localStorage.getItem("token") && (
              <Link
                className="btnClass btn-primary mx-2"
                to="/login"
                onClick={handleOnLogout}
                role="button"
              >
                Logout
              </Link>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default MyNavbar;
